<div class="modal-container">
    <h5 class="title-step mt-0 mb-3 text-center text-black">{{ title }}</h5>

    <div class="text-black">
        <p [innerHTML]="message"></p>
    </div>

    <div class="row">
        <div class="col-sm-6">
            <button class="btn d-block w-100 btn-dark" (click)="closeDialog()">No</button>
        </div>
        <div class="col-sm-6">
            <button class="btn d-block w-100 btn-green" (click)="confirm()">Sí</button>
        </div>
    </div>
</div>
